module.exports = __webpack_public_path__ + "img/rod_04.ea446b0d.svg";